module.exports = __webpack_public_path__ + "static/media/c9bannerModul1_small.87d22376.jpg";